<template>
  <div class="constom-button-container"
  :style="areaStyle"
  >
    <span @click="jumpUrl(buttonContentData)" class="constom-button" :style="buttonStyle">
      {{buttonContentData.buttonDes}}
    </span>
  </div>
</template>
<script>
import {checkMoreClickFn} from './clickJs'
export default {
  name: "optionButton",
  props: {
    data: {
      type: Object
    },
  },
  data() {
    const { tempData: { specialData, specialStyle, buttonContentData}, terminal } = this.data
    return {
      specialData,
      specialStyle,
      buttonContentData,
      terminal,
    }
  },
  computed: {
    areaStyle(){
      const {
        blockMargeTop,
        blockMargeBottom,
        blockBGClolor,
        titleAlign
      } =  this.specialStyle;
      return {
        marginTop: `${blockMargeTop?blockMargeTop:0}px`,
        marginBottom: `${blockMargeBottom?blockMargeBottom:0}px`,
        backgroundColor: blockBGClolor?blockBGClolor:'none',
        textAlign: titleAlign?titleAlign:'center',
      }
    },
    buttonStyle(){
      const {
        buttonWidth,
        buttonHeight,
        buttonColor,
        buttonBorderRadius,
      } = this.buttonContentData;
      const {
        titleColor,
        titleSize,
        titleBold,
      } = this.specialStyle
      return {
        width: `${buttonWidth?buttonWidth:120}px`,
        height: `${buttonHeight?buttonHeight:40}px`,
        fontSize: `${titleSize}px`,
        fontWeight: titleBold?'bold':'',
        color: titleColor?titleColor:'#fff',
        backgroundColor: buttonColor?buttonColor:'', // 默认样式为空
        borderRadius: `${buttonBorderRadius?buttonBorderRadius:4}px`,
        lineHeight: `${buttonHeight?buttonHeight:40}px`,
      }
    },
  },
  methods: {
    //跳转
    jumpUrl(buttonContentData){
      checkMoreClickFn(buttonContentData,this.specialData,this,true)
    },
  }
};
</script>
<style lang="less" scoped>
.constom-button-container{
  padding: 24px;
  box-sizing: border-box;
  .constom-button{
    word-break: break-all;
    display: inline-block;
    text-align: center;
  }
}
</style>
